import { EMPTY, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

/** The selected document, as far as the viewer needs it. */
export interface PreviewSelection {
    id: string;
    previewKind: string | null;
}

/** One answer of the byte route, tagged with the document it belongs to. */
export interface PreviewContent {
    documentId: string;
    bytes: ArrayBuffer | null;
    error: unknown;
}

/**
 * The bytes of the SELECTED document for the viewer.
 *
 * ⚠️ Every selection switches — a document without a PDF preview too, which switches to nothing. Before,
 * only PDFs reached the switch: picking a non-PDF left the previous PDF's poll running, and once the scan
 * released it, its bytes appeared under the new document's name, where a highlight was then saved
 * against the wrong document.
 *
 * Each answer carries its `documentId`, so a caller can also drop an answer for a document that is no
 * longer selected.
 */
export function previewContentFor(
    selection$: Observable<PreviewSelection>,
    contentOf: (documentId: string) => Observable<{ bytes: ArrayBuffer | null; error: unknown }>,
): Observable<PreviewContent> {
    return selection$.pipe(
        switchMap((doc) =>
            doc.previewKind === 'pdf'
                ? contentOf(doc.id).pipe(map(({ bytes, error }) => ({ documentId: doc.id, bytes, error })))
                : EMPTY,
        ),
    );
}
